import { Bubble, mixins } from 'vue-chartjs'
import { commaFormatString, isDecimal } from '@/helpers/index'
import {
  ADD_ATTRIBUTE
} from '@/appComponents/oldWorkbench/targetDefinition/store/actions'
import { cloneDeep } from 'lodash'

export default Bubble.extend({
  mixins: [mixins.reactiveProp],
  props: {
    axises: {
      type: Object,
      required: true
    }
  },
  computed: {
    options () {
      return {
        onClick: (event, elements) => {
          if (elements.length === 0) return
          let attribute = cloneDeep(this.chartData.datasets[elements[0]._datasetIndex].attribute)
          if (attribute.type === 'boolean') {
            this.$store.dispatch(ADD_ATTRIBUTE, attribute)
          } else if (attribute.type === 'range') {
            attribute.value = {
              min: attribute.min,
              max: attribute.max
            }
            this.$store.dispatch(ADD_ATTRIBUTE, attribute)
          } else {
            console.log(`ERROR: I don't know what to do with ${attribute.type}`)
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 30,
            right: 25,
            top: 20,
            bottom: 10
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              fontSize: 13,
              min: this.axises.x.min,
              max: this.axises.x.max,
              callback: function (value, index, values) {
                return index === values.length - 1 || (index === 0 && value !== 0) ? '' : isDecimal(value) ? value.toFixed(1) + '%' : value + '%'
              }
            }
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              padding: 2,
              fontSize: 13,
              min: this.axises.y.min,
              max: this.axises.y.max,
              callback: function (value, index, values) {
                return index === values.length - 1 || (index === 0 && value !== 0) ? '' : value === 0 ? 0 : isDecimal(value) ? value.toFixed(2) : value
              }
            }
          }]
        },
        animation: {
          duration: 0
        },
        tooltips: {
          bodyFontStyle: 'bold',
          footerFontStyle: 'normal',
          displayColors: false,
          callbacks: {
            label: function (tooltip, data) {
              return `${data.datasets[tooltip.datasetIndex].label}`
            },
            footer: function (tooltip, data) {
              return `Coverage: ${commaFormatString(String(tooltip[0].xLabel))} Index to average: ${commaFormatString(String(tooltip[0].yLabel))}`
            }
          }
        }
      }
    }
  },
  methods: {
    renderChartOnDataChange () {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.renderChartOnDataChange()
  }
})

// DEPRECATED match all files to ensure that we get all features



// WEBPACK FOOTER //
// ./src/app/appComponents/graphs/TopAttributesBubbleGraph.js